"use client";

import { useEffect } from "react";
import { Box, Typography, Button } from "@mui/material";
import * as Sentry from "@sentry/nextjs";

export default function GlobalError({ error, reset }) {
  useEffect(() => {
    // Log the error to console for development
    console.error("Global Error:", error);
    
    // Report the error to Sentry
    Sentry.captureException(error, {
      tags: {
        component: "global-error-boundary"
      },
      contexts: {
        errorBoundary: {
          componentStack: error?.componentStack || "Unknown"
        }
      }
    });
  }, [error]);

  return (
    <html>
      <body>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "100vh",
            padding: 3,
            textAlign: "center",
          }}
        >
          <Typography variant="h4" component="h2" gutterBottom>
            Something went wrong!
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            An unexpected error occurred. Please try again.
          </Typography>
          <Button variant="contained" onClick={() => reset()}>
            Try again
          </Button>
        </Box>
      </body>
    </html>
  );
}